import classNames from 'classnames';
import { api } from 'common';

import { Col, Container, Row } from 'react-bootstrap';

import { styled } from 'styled-components';

import Preferences from '../Common/Preferences';

import { Typography } from '@vivaahealth/design-system';
import ScheduleAppointmentButton, {
  VirtualVisitButton,
} from '../Common/ScheduleAppointmentButton';
import { StyledBorder } from '../Common';

interface Props {
  provider: api.PrevisitProvider.SafeProviderWithPractices;
  isInHeader?: boolean;
}

const ScheduleAppointmentCard: React.FC<Props> = ({
  provider,
  isInHeader = false,
}) => {
  const scheduleButton = (
    <ScheduleAppointmentButton
      schedulingLink={provider.preference?.schedulingLink}
      practicePhoneNumber={provider.practices[0].phoneNumber}
      fullWidth={isInHeader}
    />
  );

  const virtualVisitButton = (
    <VirtualVisitButton
      schedulingLink={provider.virtualVisitUrl ?? undefined}
      fullWidth={isInHeader}
    />
  );

  const card = (
    <>
      <Row>
        <StyledHeaderSmall
          variant="headline-small"
          bold
          className="mb-1 mb-lg-0"
        >
          Schedule an appointment
        </StyledHeaderSmall>
      </Row>
      <Preferences preference={provider.preference} />
      <Row className="mt-4 mt-lg-auto">
        <Col>{scheduleButton}</Col>
      </Row>
      {provider.virtualVisitUrl && (
        <Row className={classNames({ 'mt-2': isInHeader })}>
          <Col>{virtualVisitButton}</Col>
        </Row>
      )}
    </>
  );
  return isInHeader ? (
    <RoundedContainer fluid className="border rounded d-flex flex-column">
      {card}
    </RoundedContainer>
  ) : (
    <Container fluid className="d-flex flex-column px-0 pt-0">
      <StyledBorder className="d-md-none" />
      {card}
      <StyledBorder />
    </Container>
  );
};

export default ScheduleAppointmentCard;

const RoundedContainer = styled(Container)`
  padding: 24px;
`;

const StyledHeaderSmall = styled(Typography)`
  padding-left: 12px !important;
`;
